
export const PUBLIC_KEY_B64 =
  import.meta.env.VITE_LOGIN_ENCRYPTION_PUBLIC_KEY ||
  'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCKJ+bMM1TYOdEV+eoUp6A11bRQgZQDGL1gu7dPbBuCsw6a+SRx6ZT4db4DPXloaxIAezTELo06dd7MBQVm32r3TPKVXSjGIeIyRKTwUwF93uBwns/O3p7h8cCUAuaEJpLmDPbqUidpPnPwd/qp85QmYJK7lfPnd4uhD+FGk/mcwQIDAQAB';

// Helper: turn base64 into PEM format for RSA public keys.
export const toPemFromB64 = (b64) => {
  const wrapped = b64.replace(/\s+/g, '').match(/.{1,64}/g)?.join('\n') || b64;
  return `-----BEGIN PUBLIC KEY-----\n${wrapped}\n-----END PUBLIC KEY-----`;
};
